import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';
import { megaMenuStyle } from '../styles/MegaMenu.styles.js';

export default InjectedStyledComponent('div', 'megaMenu', ['heading'], undefined, undefined, undefined, megaMenuStyle);
